<template>
  <div class="banner">
    <div class="g-wrap content">
      <div class="left">
        <router-link class="link" :to="`${$subsitePrefix}/company/home/${data.Id}`">
          <img @error="imgError" :src="data.LogoLong" :alt="data.name" />
        </router-link>
      </div>
      <div class="right">
        <h3>
          <router-link class="link" :to="`${$subsitePrefix}/company/home/${data.Id}`">{{ data.Name }}</router-link>
        </h3>
        <p>
          <span>{{ data.industry }}</span>
          <span>{{ data.Nature }}</span>
          <span>{{ data.Scale }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "api/app";
export default {
  name: "banner",
  data() {
    return {
      id: "",
      data: {}
    };
  },
  methods: {
    init() {
      getDetail({ name: "Enterprise", id: this.id }).then(res => {
        this.data = res || {};
      });
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.banner {
  background: url(~assets/img/feature/company-banner.png) no-repeat center top;
  background-size: 100% 100%;
  height: 242px;
  .content {
    display: flex;
    align-items: center;
    height: 194px;
    .left {
      width: 212px;
      height: 66px;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      border-radius: 8px;
      background-color: #fff;
      margin-right: 24px;
      img {
        display: inline-block;
      }
    }
    .right {
      color: #fff;
      h3 {
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        padding-bottom: 10px;
        a {
          color: #fff;
        }
      }
      p {
        line-height: 24px;
        opacity: 0.8;
        font-size: 15px;
        span {
          position: relative;
          padding-left: 10px;
          margin-left: 10px;
          &::before {
            width: 1px;
            height: 12px;
            background-color: #ccc;
            position: absolute;
            left: 0;
            top: 1px;
            content: ' ';
          }
          &:first-child {
            margin-left: 0;
            padding-left: 0;
            &::before {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
